import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';

import { HGSProvider } from './hgs/context/HGSContext';
import AppShell from './hgs/layout/AppShell';
import LoginPage from './hgs/pages/LoginPage';
import DashboardPage from './hgs/pages/DashboardPage';
import RiskUniversePage from './hgs/pages/RiskUniversePage';
import LinkagePage from './hgs/pages/LinkagePage';
import PCCPage from './hgs/pages/PCCPage';
import FraudPage from './hgs/pages/FraudPage';
import DLCPage from './hgs/pages/DLCPage';
import ApprovalsPage from './hgs/pages/ApprovalsPage';
import AdminPage from './hgs/pages/AdminPage';
import MasterConfigPage from './hgs/pages/MasterConfigPage';
import QuestionBankPage from './hgs/pages/QuestionBankPage';
import GrcDashboardPage from './hgs/pages/GrcDashboardPage';
import CountermeasuresPage from './hgs/pages/CountermeasuresPage';
import GRCReviewPage from './hgs/pages/GRCReviewPage';
import MyTasksPage from './hgs/pages/MyTasksPage';
import { Toaster } from 'sonner';

function App() {
  useEffect(() => {
    const hideBadge = () => {
      const badge = document.getElementById('emergent-badge');
      if (badge) badge.remove();
    };
    hideBadge();
    const interval = setInterval(hideBadge, 300);
    const observer = new MutationObserver(hideBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => { clearInterval(interval); observer.disconnect(); };
  }, []);

  return (
    <BrowserRouter>
      <HGSProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={<AppShell><DashboardPage /></AppShell>} />
          <Route path="/risk" element={<AppShell><RiskUniversePage /></AppShell>} />
          <Route path="/linkage" element={<AppShell><LinkagePage /></AppShell>} />
          <Route path="/pcc" element={<AppShell><PCCPage /></AppShell>} />
          <Route path="/fraud" element={<AppShell><FraudPage /></AppShell>} />
          <Route path="/dlc" element={<AppShell><DLCPage /></AppShell>} />
          <Route path="/countermeasures" element={<AppShell><CountermeasuresPage /></AppShell>} />
          <Route path="/grc-review" element={<AppShell><GRCReviewPage /></AppShell>} />
          <Route path="/approvals" element={<AppShell><ApprovalsPage /></AppShell>} />
          <Route path="/admin" element={<AppShell><AdminPage /></AppShell>} />
          <Route path="/admin/masters" element={<AppShell><MasterConfigPage /></AppShell>} />
          <Route path="/admin/question-bank" element={<AppShell><QuestionBankPage /></AppShell>} />
          <Route path="/admin/grc-dashboard" element={<AppShell><GrcDashboardPage /></AppShell>} />
          <Route path="/my-tasks" element={<AppShell><MyTasksPage /></AppShell>} />
          <Route path="/" element={<Navigate to="/my-tasks" replace />} />
          <Route path="*" element={<Navigate to="/my-tasks" replace />} />
        </Routes>
      </HGSProvider>
      <Toaster position="bottom-right" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
